export type ChartLegendItem = {
  name: string;
  color: string;
  visible?: boolean;
};

export type ChartLegendProps = {
  items: ChartLegendItem[];
  className?: string;
};

const ChartLegend = ({ items, className = "" }: ChartLegendProps) => {
  const visibleItems = items.filter((item) => item.visible !== false);

  return (
    <div className={`flex w-full flex-wrap gap-x-4 gap-y-2 ${className}`.trim()}>
      {visibleItems.map((item, index) => (
        <div key={`legend-item-${index}`} className="flex min-w-[min(100%,11rem)] max-w-full items-start gap-2">
          <div
            className="mt-1.5 h-2 w-[21px] shrink-0"
            style={{ backgroundColor: item.color }}
            data-testid="legend-color"
          />
          <p className="break-words text-label-medium text-sys-brand-on-surface-variant">{item.name}</p>
        </div>
      ))}
    </div>
  );
};

export default ChartLegend;
